import BomSourceSerializer from 'eflex/serializers/bom-source';

export default class OracleDellBoomiBomSourceSerializer extends BomSourceSerializer {}
